// Menu Components JS

// Mobile Menu Toggle
class MobileMenuToggle {
    constructor() {
        this.toggleButton = document.querySelector('.menu-toggle');
        this.navMenu = document.querySelector('.nav-menu');
        this.isOpen = false;

        if (this.toggleButton && this.navMenu) {
            this.init();
        }
    }

    init() {
        this.toggleButton.addEventListener('click', () => {
            this.toggleMenu();
        });

        document.addEventListener('click', (e) => {
            if (!this.toggleButton.contains(e.target) && !this.navMenu.contains(e.target)) {
                this.closeMenu();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.closeMenu();
            }
        });
    }

    toggleMenu() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.openMenu();
        } else {
            this.closeMenu();
        }
    }

    openMenu() {
        this.navMenu.classList.add('active');
        this.toggleButton.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    closeMenu() {
        this.navMenu.classList.remove('active');
        this.toggleButton.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        this.isOpen = false;
        // Reset submenu checkboxes so they start closed on next open
        this.navMenu.querySelectorAll('.sub-menu-checkbox').forEach(cb => {
            cb.checked = false;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MobileMenuToggle();
});
